// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb_breadcrumbs__3_0z9","bread_crumb_item":"breadcrumb_bread_crumb_item__3Trk7","active":"breadcrumb_active__3aybb"};